import { useState } from "react"
import { useSubscription } from "../App/useSubscription"
import type { SubscriptionToken } from "../Types/Generated/LogbookApi/Subscriptions"

export function useAuthoritativeSeedIds<Row extends { id: number }>(
  seed: readonly Row[] | undefined,
  subscription: SubscriptionToken<Row>,
  belongsToScope: (row: Row) => boolean,
): ReadonlySet<number> | undefined {
  const [ids, setIds] = useState<Set<number> | undefined>(
    () => seed === undefined ? undefined : new Set(seed.map((row) => row.id)),
  );

  useSubscription((row: Row) => {
    setIds((current) => {
      if (current === undefined || !belongsToScope(row) || current.has(row.id)) {
        return current;
      }
      const next = new Set(current);
      next.add(row.id);
      return next;
    });
  }, subscription);

  return ids;
}
